export default __webpack_public_path__ + "static/background-pattern-26e6dbe3813500734aa3e5f2c85fccec.png";